import React from 'react'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

import { Section } from '../../components/Section'
import { getAiSearchMetrics } from './data'

export function SectionAiSearchMetrics() {
  const intl = useIntl()
  const metrics = getAiSearchMetrics(intl)

  return (
    <Section
      containerVerticalPadding={60}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'grid-12 grid-gap-24',
          'margin-left-auto margin-right-auto text-align-center'
        )}
        style={{ maxWidth: 1000 }}
      >
        {metrics.map((m) => (
          <div
            key={m.value}
            className="grid-span-4-large grid-span-4-medium grid-span-12-small flexbox flexbox-column flexbox-align-center"
          >
            <div
              className="font-family-title font-weight-medium shade-05"
              style={{ fontSize: '3rem', lineHeight: 1.1 }}
            >
              {m.value}
            </div>
            <div className="font-size-4 shade-20 margin-top-8">{m.label}</div>
          </div>
        ))}
      </div>
    </Section>
  )
}
